import { render, staticRenderFns } from "./AwardsModal.vue?vue&type=template&id=df31171e"
import script from "./AwardsModal.vue?vue&type=script&lang=js"
export * from "./AwardsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports